import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const SiteContext = createContext({ settings: null, refresh: () => {} });

export function SiteProvider({ children }) {
  const [settings, setSettings] = useState(null);

  const refresh = () => {
    api.get("/settings").then((r) => setSettings(r.data)).catch(() => {});
  };

  useEffect(() => {
    refresh();
  }, []);

  return <SiteContext.Provider value={{ settings, refresh }}>{children}</SiteContext.Provider>;
}

export function useSite() {
  return useContext(SiteContext);
}

/** Texte éditable du site : valeur saisie dans l'admin, sinon texte par défaut. */
export function siteText(settings, key, fallback) {
  const v = settings?.texts?.[key];
  return v ? v : fallback;
}
